import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewEncapsulation, Input, Output, Inject, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import { NavigationStart, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@highfieldabc/angular-highfieldauth';
import { AngularHighfieldauthModule } from '@highfieldabc/angular-highfieldauth';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@highfieldabc/angular-highfieldwebapi';
import { AngularHighfieldwebapiModule } from '@highfieldabc/angular-highfieldwebapi';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i1$2 from '@highfieldabc/angular-highfieldcommon';
import { AngularHighfieldcommonModule } from '@highfieldabc/angular-highfieldcommon';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
function AuthenticationComponent_li_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 6);
    i0.ɵɵlistener("click", function AuthenticationComponent_li_5_Template_a_click_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r3);
      const profileMenuOption_r1 = restoredCtx.$implicit;
      return i0.ɵɵresetView(profileMenuOption_r1.action());
    });
    i0.ɵɵelement(2, "i");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const profileMenuOption_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(profileMenuOption_r1.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" \xA0 ", profileMenuOption_r1.label, "");
  }
}
function AdminContainerComponent_ng_container_5_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵlistener("click", function AdminContainerComponent_ng_container_5_li_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const menuSet_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.setCurrentMenuSet(menuSet_r3));
    });
    i0.ɵɵelementStart(1, "a", 23);
    i0.ɵɵelement(2, "i");
    i0.ɵɵtext(3, "\xA0");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const menuSet_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r4.getMenuSetClass(menuSet_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(menuSet_r3.iconClass);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(menuSet_r3.name);
  }
}
function AdminContainerComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AdminContainerComponent_ng_container_5_li_1_Template, 6, 4, "li", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const menuSet_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.validateRole(menuSet_r3));
  }
}
function AdminContainerComponent_ng_container_18_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵlistener("click", function AdminContainerComponent_ng_container_18_li_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const topMenuItem_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.setCurrentTopMenuItem(topMenuItem_r9));
    });
    i0.ɵɵelementStart(1, "a", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const topMenuItem_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r10.getTopMenuItemClass(topMenuItem_r9));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(topMenuItem_r9.name);
  }
}
function AdminContainerComponent_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AdminContainerComponent_ng_container_18_li_1_Template, 3, 2, "li", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const topMenuItem_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validateRole(topMenuItem_r9));
  }
}
function AdminContainerComponent_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28)(2, "span", 29);
    i0.ɵɵtext(3, "Loading...");
    i0.ɵɵelementEnd()()();
  }
}
const _c0 = a0 => ({
  "padding-bottom": a0
});
const _c1 = ["*"];
function CustomerContainerComponent_ng_container_5_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵlistener("click", function CustomerContainerComponent_ng_container_5_li_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const menuSet_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.setCurrentMenuSet(menuSet_r3));
    });
    i0.ɵɵelementStart(1, "a", 23);
    i0.ɵɵelement(2, "i");
    i0.ɵɵtext(3, "\xA0");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const menuSet_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r4.getMenuSetClass(menuSet_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(menuSet_r3.iconClass);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(menuSet_r3.name);
  }
}
function CustomerContainerComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerContainerComponent_ng_container_5_li_1_Template, 6, 4, "li", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const menuSet_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.validateRole(menuSet_r3));
  }
}
function CustomerContainerComponent_ng_container_18_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵlistener("click", function CustomerContainerComponent_ng_container_18_li_1_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const topMenuItem_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.setCurrentTopMenuItem(topMenuItem_r9));
    });
    i0.ɵɵelementStart(1, "a", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const topMenuItem_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r10.getTopMenuItemClass(topMenuItem_r9));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(topMenuItem_r9.name);
  }
}
function CustomerContainerComponent_ng_container_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerContainerComponent_ng_container_18_li_1_Template, 3, 2, "li", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const topMenuItem_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.validateRole(topMenuItem_r9));
  }
}
function CustomerContainerComponent_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28)(2, "span", 29);
    i0.ɵɵtext(3, "Loading...");
    i0.ɵɵelementEnd()()();
  }
}
const _c2 = ".navbar{width:100%}.dropdown-toggle{outline:none}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.order-13{order:13}.order-14{order:14}.order-15{order:15}.order-16{order:16}.order-17{order:17}.order-18{order:18}.order-19{order:19}.order-20{order:20}.order-21{order:21}.order-22{order:22}.order-23{order:23}.order-24{order:24}.order-25{order:25}.order-26{order:26}.order-27{order:27}.order-28{order:28}.order-29{order:29}.order-30{order:30}.order-31{order:31}.order-32{order:32}.order-33{order:33}.order-34{order:34}.order-35{order:35}.order-36{order:36}.order-37{order:37}.order-38{order:38}.order-39{order:39}.order-40{order:40}.order-41{order:41}.order-42{order:42}.order-43{order:43}.order-44{order:44}.order-45{order:45}.order-46{order:46}.order-47{order:47}.order-48{order:48}.order-49{order:49}.order-50{order:50}.container-content{background-color:#fff;padding:32px;overflow-y:scroll;flex-direction:column}hr{border-top:2px solid #fff!important;opacity:1!important}.profile-text{text-overflow:ellipsis;white-space:nowrap;width:100%;padding:0 16px}.loading-overlay{display:flex;background:#ffffffb3;position:fixed;inset:0;z-index:9998;align-items:center;justify-content:center}\n";
function LoginComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "highfieldauth-login-page");
    i0.ɵɵelementEnd();
  }
}
function BaseContainerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function BaseContainerComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2, "Loading...");
    i0.ɵɵelementEnd()();
  }
}
function BaseContainerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.loadingMessage);
  }
}
let LoadingService = /*#__PURE__*/(() => {
  class LoadingService {
    constructor() {
      this.isLoading = false;
      this.loadingMessage = "";
      this.loadingChanged = new BehaviorSubject(this.isLoading);
    }
    setLoading(loading, message = "") {
      this.isLoading = loading;
      this.loadingMessage = message;
      this.loadingChanged.next(this.isLoading);
    }
    getLoading() {
      return this.isLoading;
    }
    static {
      this.ɵfac = function LoadingService_Factory(t) {
        return new (t || LoadingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoadingService,
        factory: LoadingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LoadingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthenticationComponent = /*#__PURE__*/(() => {
  class AuthenticationComponent {
    constructor(currentUserService, route, router, authService) {
      this.currentUserService = currentUserService;
      this.route = route;
      this.router = router;
      this.authService = authService;
      this.loginPath = '';
      this.welcomePath = '';
      this.onLogout = new EventEmitter();
      this.profileMenuOptions = [];
      this.displayProfile = false;
      this.currentuser = null;
      this.isLoginVisible = false;
      this.isLoginActive = false;
      this.userWatcher = null;
    }
    ngOnInit() {
      this.userWatcher = this.currentUserService.dispatcher.subscribe(user => {
        this.currentuser = user.User;
      });
    }
    canActivate(route, state) {
      const url = state.url;
      return this.checkLogin(url);
    }
    checkLogin(url) {
      return this.checkCurrentUser(url);
    }
    checkCurrentUser(url) {
      if (this.currentUserService.getCurrentUser().User !== null) {
        return true;
      }
      this.router.navigate(['/login'], {
        queryParams: {
          returnUrl: url !== '/' ? url : null
        }
      });
      return false;
    }
    loginClick() {
      this.router.navigate(['/login']);
    }
    logoutClick() {
      this.currentUserService.setCurrentUser(null);
      this.onLogout.emit();
    }
    toggleProfileVisible() {
      this.displayProfile = !this.displayProfile;
    }
    getUserInitials() {
      if (this.currentuser && this.currentuser.firstName && this.currentuser.lastName) {
        return `${this.currentuser.firstName[0]} ${this.currentuser.lastName[0]}`;
      } else {
        return '';
      }
    }
    triggerProfileMenuOption(profileMenuOption) {
      profileMenuOption.action();
    }
    static {
      this.ɵfac = function AuthenticationComponent_Factory(t) {
        return new (t || AuthenticationComponent)(i0.ɵɵdirectiveInject(i1.CurrentUserService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.AuthenticationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuthenticationComponent,
        selectors: [["highfieldlayout-auth-component"]],
        inputs: {
          loginPath: "loginPath",
          welcomePath: "welcomePath",
          profileMenuOptions: "profileMenuOptions"
        },
        outputs: {
          onLogout: "onLogout"
        },
        decls: 10,
        vars: 2,
        consts: [[1, "dropdown", "d-flex", "justify-content-center", "pb-2"], ["data-bs-toggle", "dropdown", 1, "d-flex", "align-items-center", "text-light", "text-decoration-none"], [1, "rounded-circle", "bg-light", "text-dark", "profile-icon", "d-flex", "justify-content-center", "align-items-center", 2, "height", "36px", "width", "36px"], [3, "innerHTML"], [1, "dropdown-menu", "dropdown-menu-light", "text-small", "shadow"], [4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"], [1, "fas", "fa-sign-out-alt"]],
        template: function AuthenticationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "a", 1)(2, "div", 2);
            i0.ɵɵelement(3, "strong", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "ul", 4);
            i0.ɵɵtemplate(5, AuthenticationComponent_li_5_Template, 4, 3, "li", 5);
            i0.ɵɵelementStart(6, "li")(7, "a", 6);
            i0.ɵɵlistener("click", function AuthenticationComponent_Template_a_click_7_listener() {
              return ctx.logoutClick();
            });
            i0.ɵɵelement(8, "i", 7);
            i0.ɵɵtext(9, " \xA0 Log out");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", ctx.getUserInitials(), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.profileMenuOptions);
          }
        },
        dependencies: [i4.NgForOf],
        styles: ["#HighfieldQualifications .HighfieldHeader #layout-header-placeholder{background-image:url(https://cdn.highfieldqualifications.com/layout/CirQUAL.png);background-position:center;background-size:contain;background-repeat:no-repeat}#HighfieldQualifications .login-background-image{background-image:url(https://cdn.highfieldqualifications.com/layout/LoginHQ.png)}#HighfieldQualifications #profile-button{color:#fff;background-color:#159ed9;border-bottom-color:#0c597a}#HighfieldQualifications #logout-button{color:#fff;background-color:#159ed9;border-bottom:3px solid #0C597A!important}#HighfieldQualifications #layout-profile-button{background-color:transparent;color:#159ed9}#HighfieldQualifications #profilePanel>.ui-overlaypanel{background-color:#fff}#HighfieldQualifications #profileOverlayHeader{background:url(https://cdn.highfieldqualifications.com/layout/ProfileHeaderBackQuals.png);background-size:cover}#HighfieldQualifications #profileOverlayHeaderText{color:#fff}#HighfieldAssessment .HighfieldHeader #layout-header-placeholder{background-image:url(https://cdn.highfieldqualifications.com/layout/CirASSE.png);background-position:center;background-size:contain;background-repeat:no-repeat}#HighfieldAssessment .login-background-image{background-image:url(https://cdn.highfieldqualifications.com/layout/LoginHA.png)}#HighfieldAssessment #profile-button{color:#fff;background-color:#e84d0e;border-bottom-color:#fbd5c8}#HighfieldAssessment #logout-button{color:#fff;background-color:#e84d0e;border-bottom:3px solid #fbd5c8!important}#HighfieldAssessment #layout-profile-button{background-color:transparent;color:#e84d0e}#HighfieldAssessment #profilePanel>.ui-overlaypanel{background-color:#fff}#HighfieldAssessment #profileOverlayHeader{background:url(https://cdn.highfieldqualifications.com/layout/ProfileHeaderBackAss.png);background-size:cover}#HighfieldAssessment #profileOverlayHeaderText{color:#fff}#button-row{padding:15px;display:flex}#profile-button,#logout-button{width:100%;margin:0;border:0;padding:8px 15px;border-bottom:3px solid;outline:none}#currentUserProfile{position:fixed;top:0;right:0;left:auto;height:70px}#layout-profile-button{display:block;height:70px;width:70px;border:none;outline:0!important}#profilePanel>.ui-overlaypanel{left:-230px!important;top:70px!important;box-shadow:0 4px 8px #0003}.ui-overlaypanel-content{padding:0!important}#profileOverlayHeader{height:100px;padding:5px 0;margin:0;display:table;table-layout:fixed;width:100%}#profileOverlayHeaderText{display:table-cell;width:100%;text-align:left;vertical-align:middle;padding:0 10px;text-align:center;font-size:24px}.profileOverlayMenu{list-style:none;margin:0;padding:0}.rounded-circle{height:52px!important;width:52px!important}.pointer{cursor:pointer}\n"],
        encapsulation: 2
      });
    }
  }
  return AuthenticationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AdminContainerComponent = /*#__PURE__*/(() => {
  class AdminContainerComponent {
    constructor(router, loadingService, currentUserService, authGuardService) {
      this.router = router;
      this.loadingService = loadingService;
      this.currentUserService = currentUserService;
      this.authGuardService = authGuardService;
      this.profileText = '';
      this.profileMenuOptions = [];
      this.highfieldSite = '';
      this.siteTitle = '';
      this.siteSubTitle = '';
      this.loginPath = '';
      this.welcomePath = '';
      this.onLogout = new EventEmitter();
      this.menuSets = [];
      this.currentYear = new Date().getFullYear();
      this.loading = false;
      // Horrible hack to play nicely with EPA Dashboard Centre Select menu below the top icon
      this.customPaddingBottom = '1rem';
      this.loadingService.loadingChanged.subscribe(loading => {
        this.loading = loading;
      });
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.loadingService.setLoading(true);
        } else if (event instanceof NavigationEnd) {
          this.loadingService.setLoading(false);
          this.updateMenuItem();
        }
      });
    }
    ngOnInit() {
      this.setSelectedTopMenuItem();
      this.updateMenuItem();
    }
    onLogoutClick() {
      this.onLogout.emit();
    }
    getStyleClass() {
      if (this.highfieldSite == null || this.highfieldSite == undefined || this.highfieldSite == '') {
        return 'HighfieldQualifications';
      } else {
        return this.highfieldSite;
      }
    }
    getMenuSetClass(menuSet) {
      return `nav-item order-${menuSet.order}${menuSet.selected ? ' active' : ''}`;
    }
    getTopMenuItemClass(topMenuItem) {
      return `nav-item order-${topMenuItem.order}${topMenuItem.selected ? ' active' : ''}`;
    }
    setCurrentMenuSet(menuSet) {
      this.menuSets.forEach(x => x.selected = false);
      this.currentMenuSet = menuSet;
      this.currentMenuSet.selected = true;
      const defaultTopMenuItem = this.currentMenuSet.topMenuItems.find(x => x.default);
      if (defaultTopMenuItem !== undefined) {
        this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
        defaultTopMenuItem.selected = true;
        this.router.navigateByUrl(`/admin${this.currentMenuSet.baseRoute}${defaultTopMenuItem.childRoute}`);
      } else {
        throw new Error('No default top menu item defined');
      }
    }
    setCurrentTopMenuItem(topMenuItem) {
      this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
      topMenuItem.selected = true;
      this.router.navigateByUrl(`/admin${this.currentMenuSet.baseRoute}${topMenuItem.childRoute}`);
    }
    getTopMenuItems() {
      if (this.currentMenuSet) {
        return this.currentMenuSet.topMenuItems.filter(x => x.display);
      } else {
        return [];
      }
    }
    setSelectedTopMenuItem() {
      const defaultMenuSet = this.menuSets.find(x => x.default);
      const flatRoutes = this.menuSets.map(x => x.topMenuItems.map(y => {
        return {
          url: `/admin${x.baseRoute}${y.childRoute}`,
          menuSet: x
        };
      })).reduce((x, y) => x.concat(y), []);
      const routedSet = flatRoutes.find(x => this.router.url.startsWith(x.url));
      const currentRoutedMenuSet = routedSet ? routedSet.menuSet : undefined;
      if (currentRoutedMenuSet !== undefined) {
        this.currentMenuSet = currentRoutedMenuSet;
        const selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => this.router.url.indexOf(x.childRoute) !== -1);
        if (selectedTopMenuItem !== undefined) {
          selectedTopMenuItem.selected = true;
        }
        this.currentMenuSet.selected = true;
      } else if (defaultMenuSet !== undefined) {
        this.currentMenuSet = defaultMenuSet;
        const selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => this.router.url.indexOf(x.childRoute) !== -1);
        this.setCurrentMenuSet(this.currentMenuSet);
        this.setCurrentTopMenuItem(selectedTopMenuItem);
      } else {
        throw new Error('No default menu set defined');
      }
    }
    userHasRole(role) {
      let roles = this.currentUserService.getCurrentUser().User?.roles;
      return roles.includes(role);
    }
    validateRole(menuItem) {
      if (menuItem.roles?.length) {
        for (let menuRole of menuItem.roles) {
          if (this.userHasRole(menuRole)) {
            return true;
          }
        }
        return false;
      }
      return true;
    }
    updateMenuItem() {
      if (this.currentMenuSet) {
        const childRouteIsEmpty = this.router.url.endsWith(this.currentMenuSet.baseRoute);
        let selectedTopMenuItem;
        if (childRouteIsEmpty) {
          selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => !x.childRoute);
        } else {
          selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => !!x.childRoute && this.router.url.indexOf(x.childRoute) !== -1);
        }
        this.menuSets.forEach(x => x.selected = false);
        this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
        if (selectedTopMenuItem) {
          selectedTopMenuItem.selected = true;
        }
        this.currentMenuSet.selected = true;
      }
    }
    static {
      this.ɵfac = function AdminContainerComponent_Factory(t) {
        return new (t || AdminContainerComponent)(i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(LoadingService), i0.ɵɵdirectiveInject(i1.CurrentUserService), i0.ɵɵdirectiveInject(i1.AuthGuardService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AdminContainerComponent,
        selectors: [["highfieldlayout-admincontainer-component"]],
        inputs: {
          profileText: "profileText",
          profileMenuOptions: "profileMenuOptions",
          highfieldSite: "highfieldSite",
          siteTitle: "siteTitle",
          siteSubTitle: "siteSubTitle",
          loginPath: "loginPath",
          welcomePath: "welcomePath",
          menuSets: "menuSets",
          customPaddingBottom: "customPaddingBottom"
        },
        outputs: {
          onLogout: "onLogout"
        },
        ngContentSelectors: _c1,
        decls: 26,
        vars: 11,
        consts: [[1, "d-flex", "vh-100", "overflow-hidden", 3, "id"], [1, "d-flex", "flex-column", "flex-shrink-0", "text-white", "bg-dark", "side-menu"], [1, "d-flex", "align-items-center", "text-white", "text-decoration-none", "justify-content-center", 3, "ngStyle"], ["src", "https://cdn.highfieldqualifications.com/resources/branding/crest-white.png"], [1, "nav", "side-nav", "flex-column", "mb-auto", "d-block", "overflow-auto"], [4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "text-white", "text-decoration-none", "justify-content-center", "flex-column"], [3, "profileMenuOptions", "onLogout"], [1, "profile-text", "text-center", 3, "innerHTML"], [1, "d-flex", "flex-grow-1", "flex-column"], [1, "row", "row-nav", "ps-2"], [1, "title"], [1, "row", "row-nav", "nav-items", "ps-2"], [1, "d-flex", "nav-header"], [1, "navbar", "nav", "navbar-expand-lg", "d-flex", "align-items-end"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "mr-auto", "top-nav"], [1, "d-flex", "flex-grow-1", "container-content"], [1, "d-flex", "justify-content-center", "align-items-center", "footer"], ["src", "https://cdn.highfieldqualifications.com/resources/branding/HG%20Logo.png", "alt", "Highfield Awarding Body for Compliance Limited", 1, "me-3"], ["class", "loading-overlay", 4, "ngIf"], ["class", "mb-1", 3, "ngClass", "click", 4, "ngIf"], [1, "mb-1", 3, "ngClass", "click"], [1, "nav-link"], ["class", "top-nav-item", 3, "ngClass", "click", 4, "ngIf"], [1, "top-nav-item", 3, "ngClass", "click"], [1, "nav-item"], [1, "loading-overlay"], ["role", "status", 1, "spinner-border", "text-primary"], [1, "sr-only"]],
        template: function AdminContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "img", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 4);
            i0.ɵɵtemplate(5, AdminContainerComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6)(7, "highfieldlayout-auth-component", 7);
            i0.ɵɵlistener("onLogout", function AdminContainerComponent_Template_highfieldlayout_auth_component_onLogout_7_listener() {
              return ctx.onLogoutClick();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "div", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 9)(10, "div", 10)(11, "h2", 11);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 12)(14, "div", 13)(15, "nav", 14)(16, "div", 15)(17, "ul", 16);
            i0.ɵɵtemplate(18, AdminContainerComponent_ng_container_18_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(19, "div", 17);
            i0.ɵɵprojection(20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "div", 18);
            i0.ɵɵelement(22, "img", 19);
            i0.ɵɵelementStart(23, "strong");
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(25, AdminContainerComponent_div_25_Template, 4, 0, "div", 20);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.getStyleClass());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c0, ctx.customPaddingBottom));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.menuSets);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("profileMenuOptions", ctx.profileMenuOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.profileText, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.currentMenuSet.titleOverride || ctx.currentMenuSet.name);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngForOf", ctx.getTopMenuItems());
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1("\xA9 ", ctx.currentYear, " Highfield Awarding Body for Compliance Limited");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
          }
        },
        dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgStyle, AuthenticationComponent],
        styles: [".navbar{width:100%}.dropdown-toggle{outline:none}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.order-13{order:13}.order-14{order:14}.order-15{order:15}.order-16{order:16}.order-17{order:17}.order-18{order:18}.order-19{order:19}.order-20{order:20}.order-21{order:21}.order-22{order:22}.order-23{order:23}.order-24{order:24}.order-25{order:25}.order-26{order:26}.order-27{order:27}.order-28{order:28}.order-29{order:29}.order-30{order:30}.order-31{order:31}.order-32{order:32}.order-33{order:33}.order-34{order:34}.order-35{order:35}.order-36{order:36}.order-37{order:37}.order-38{order:38}.order-39{order:39}.order-40{order:40}.order-41{order:41}.order-42{order:42}.order-43{order:43}.order-44{order:44}.order-45{order:45}.order-46{order:46}.order-47{order:47}.order-48{order:48}.order-49{order:49}.order-50{order:50}.container-content{background-color:#fff;padding:32px;overflow-y:scroll;flex-direction:column}hr{border-top:2px solid #fff!important;opacity:1!important}.profile-text{text-overflow:ellipsis;white-space:nowrap;width:100%;padding:0 16px}.loading-overlay{display:flex;background:#ffffffb3;position:fixed;inset:0;z-index:9998;align-items:center;justify-content:center}\n"],
        encapsulation: 2
      });
    }
  }
  return AdminContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomerContainerComponent = /*#__PURE__*/(() => {
  class CustomerContainerComponent {
    constructor(router, loadingService, currentUserService) {
      this.router = router;
      this.loadingService = loadingService;
      this.currentUserService = currentUserService;
      this.highfieldSite = '';
      this.siteTitle = '';
      this.siteSubTitle = '';
      this.loginPath = '';
      this.welcomePath = '';
      this.onLogout = new EventEmitter();
      this.profileText = '';
      this.profileMenuOptions = [];
      this.menuSets = [];
      this.currentYear = new Date().getFullYear();
      this.loading = false;
      // Horrible hack to play nicely with EPA Dashboard Centre Select menu below the top icon
      this.customPaddingBottom = '1rem';
      this.loadingService.loadingChanged.subscribe(loading => {
        this.loading = loading;
      });
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.loadingService.setLoading(true);
        } else if (event instanceof NavigationEnd) {
          this.loadingService.setLoading(false);
          this.updateMenuItem();
        }
      });
    }
    ngOnInit() {
      this.setSelectedTopMenuItem();
      this.updateMenuItem();
    }
    onLogoutClick() {
      this.onLogout.emit();
    }
    getStyleClass() {
      if (this.highfieldSite == null || this.highfieldSite == undefined || this.highfieldSite == '') {
        return 'HighfieldQualifications';
      } else {
        return this.highfieldSite;
      }
    }
    getMenuSetClass(menuSet) {
      return `side-nav-item order-${menuSet.order}${menuSet.selected ? ' active' : ''}`;
    }
    getTopMenuItemClass(topMenuItem) {
      return `top-nav-item order-${topMenuItem.order}${topMenuItem.selected ? ' active' : ''}`;
    }
    setCurrentMenuSet(menuSet) {
      this.menuSets.forEach(x => x.selected = false);
      this.currentMenuSet = menuSet;
      this.currentMenuSet.selected = true;
      const defaultTopMenuItem = this.currentMenuSet.topMenuItems.find(x => x.default);
      if (defaultTopMenuItem !== undefined) {
        this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
        defaultTopMenuItem.selected = true;
        this.router.navigateByUrl(`/customer${this.currentMenuSet.baseRoute}${defaultTopMenuItem.childRoute}`);
      } else {
        throw new Error('No default top menu item defined');
      }
    }
    setCurrentTopMenuItem(topMenuItem) {
      this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
      topMenuItem.selected = true;
      this.router.navigateByUrl(`/customer${this.currentMenuSet.baseRoute}${topMenuItem.childRoute}`);
    }
    getTopMenuItems() {
      if (this.currentMenuSet) {
        return this.currentMenuSet.topMenuItems.filter(x => x.display);
      } else {
        return [];
      }
    }
    userHasRole(role) {
      let roles = this.currentUserService.getCurrentUser().User?.roles;
      return roles.includes(role);
    }
    validateRole(menuItem) {
      if (menuItem.roles?.length) {
        for (let menuRole of menuItem.roles) {
          if (this.userHasRole(menuRole)) {
            return true;
          }
        }
        return false;
      }
      return true;
    }
    setSelectedTopMenuItem() {
      const defaultMenuSet = this.menuSets.find(x => x.default);
      const flatRoutes = this.menuSets.map(x => x.topMenuItems.map(y => {
        return {
          url: `/admin${x.baseRoute}${y.childRoute}`,
          menuSet: x
        };
      })).reduce((x, y) => x.concat(y), []);
      const routedSet = flatRoutes.find(x => this.router.url.startsWith(x.url));
      const currentRoutedMenuSet = routedSet ? routedSet.menuSet : undefined;
      if (currentRoutedMenuSet !== undefined) {
        this.currentMenuSet = currentRoutedMenuSet;
        const selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => this.router.url.indexOf(x.childRoute) !== -1);
        if (selectedTopMenuItem !== undefined) {
          selectedTopMenuItem.selected = true;
        }
        this.currentMenuSet.selected = true;
      } else if (defaultMenuSet !== undefined) {
        this.currentMenuSet = defaultMenuSet;
        const selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => this.router.url.indexOf(x.childRoute) !== -1);
        this.setCurrentMenuSet(this.currentMenuSet);
        this.setCurrentTopMenuItem(selectedTopMenuItem);
      } else {
        throw new Error('No default menu set defined');
      }
    }
    updateMenuItem() {
      if (this.currentMenuSet) {
        const childRouteIsEmpty = this.router.url.endsWith(this.currentMenuSet.baseRoute);
        let selectedTopMenuItem;
        if (childRouteIsEmpty) {
          selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => !x.childRoute);
        } else {
          selectedTopMenuItem = this.currentMenuSet.topMenuItems.find(x => !!x.childRoute && this.router.url.indexOf(x.childRoute) !== -1);
        }
        this.menuSets.forEach(x => x.selected = false);
        this.currentMenuSet.topMenuItems.forEach(x => x.selected = false);
        if (selectedTopMenuItem) {
          selectedTopMenuItem.selected = true;
        }
        this.currentMenuSet.selected = true;
      }
    }
    static {
      this.ɵfac = function CustomerContainerComponent_Factory(t) {
        return new (t || CustomerContainerComponent)(i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(LoadingService), i0.ɵɵdirectiveInject(i1.CurrentUserService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomerContainerComponent,
        selectors: [["highfieldlayout-customercontainer-component"]],
        inputs: {
          highfieldSite: "highfieldSite",
          siteTitle: "siteTitle",
          siteSubTitle: "siteSubTitle",
          loginPath: "loginPath",
          welcomePath: "welcomePath",
          profileText: "profileText",
          profileMenuOptions: "profileMenuOptions",
          menuSets: "menuSets",
          customPaddingBottom: "customPaddingBottom"
        },
        outputs: {
          onLogout: "onLogout"
        },
        ngContentSelectors: _c1,
        decls: 26,
        vars: 11,
        consts: [[1, "d-flex", "vh-100", "overflow-hidden", 3, "id"], [1, "d-flex", "flex-column", "flex-shrink-0", "text-white", "bg-dark", "side-menu"], [1, "d-flex", "align-items-center", "text-white", "text-decoration-none", "justify-content-center", 3, "ngStyle"], ["src", "https://cdn.highfieldqualifications.com/resources/branding/crest-white.png"], [1, "nav", "side-nav", "flex-column", "mb-auto", "d-block", "overflow-auto"], [4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "text-white", "text-decoration-none", "justify-content-center", "flex-column"], [3, "profileMenuOptions", "onLogout"], [1, "profile-text", "text-center", 3, "innerHTML"], [1, "d-flex", "flex-grow-1", "flex-column"], [1, "row", "row-nav", "ps-2"], [1, "title"], [1, "row", "row-nav", "nav-items", "ps-2"], [1, "d-flex", "nav-header"], [1, "navbar", "nav", "navbar-expand-lg", "d-flex", "align-items-end"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "mr-auto", "top-nav"], [1, "d-flex", "flex-grow-1", "container-content"], [1, "d-flex", "justify-content-center", "align-items-center", "footer"], ["src", "https://cdn.highfieldqualifications.com/resources/branding/HG%20Logo.png", "alt", "Highfield Awarding Body for Compliance Limited", 1, "me-3"], ["class", "loading-overlay", 4, "ngIf"], ["class", "mb-1", 3, "ngClass", "click", 4, "ngIf"], [1, "mb-1", 3, "ngClass", "click"], [1, "nav-link"], ["class", "top-nav-item", 3, "ngClass", "click", 4, "ngIf"], [1, "top-nav-item", 3, "ngClass", "click"], [1, "nav-item"], [1, "loading-overlay"], ["role", "status", 1, "spinner-border", "text-primary"], [1, "sr-only"]],
        template: function CustomerContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "img", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 4);
            i0.ɵɵtemplate(5, CustomerContainerComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6)(7, "highfieldlayout-auth-component", 7);
            i0.ɵɵlistener("onLogout", function CustomerContainerComponent_Template_highfieldlayout_auth_component_onLogout_7_listener() {
              return ctx.onLogoutClick();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "div", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 9)(10, "div", 10)(11, "h2", 11);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 12)(14, "div", 13)(15, "nav", 14)(16, "div", 15)(17, "ul", 16);
            i0.ɵɵtemplate(18, CustomerContainerComponent_ng_container_18_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(19, "div", 17);
            i0.ɵɵprojection(20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "div", 18);
            i0.ɵɵelement(22, "img", 19);
            i0.ɵɵelementStart(23, "strong");
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(25, CustomerContainerComponent_div_25_Template, 4, 0, "div", 20);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.getStyleClass());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c0, ctx.customPaddingBottom));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.menuSets);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("profileMenuOptions", ctx.profileMenuOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.profileText, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.currentMenuSet.titleOverride || ctx.currentMenuSet.name);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngForOf", ctx.getTopMenuItems());
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1("\xA9 ", ctx.currentYear, " Highfield Awarding Body for Compliance Limited");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
          }
        },
        dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i4.NgStyle, AuthenticationComponent],
        styles: [_c2],
        encapsulation: 2
      });
    }
  }
  return CustomerContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicContainerComponent = /*#__PURE__*/(() => {
  class PublicContainerComponent {
    constructor(router, loadingService) {
      this.loadingService = loadingService;
      this.highfieldSite = '';
      this.siteTitle = '';
      this.siteSubTitle = '';
      this.loginPath = '';
      this.welcomePath = '';
      this.onLogout = new EventEmitter();
      router.events.forEach(event => {
        if (event instanceof NavigationStart) {
          this.loadingService.setLoading(true);
        } else if (event instanceof NavigationEnd) {
          this.loadingService.setLoading(false);
        }
      });
    }
    ngOnInit() {}
    onLogoutClick() {
      this.onLogout.emit();
    }
    getStyleClass() {
      if (this.highfieldSite == null || this.highfieldSite == undefined || this.highfieldSite == '') {
        return 'HighfieldQualifications';
      } else {
        return this.highfieldSite;
      }
    }
    static {
      this.ɵfac = function PublicContainerComponent_Factory(t) {
        return new (t || PublicContainerComponent)(i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(LoadingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PublicContainerComponent,
        selectors: [["highfieldlayout-publiccontainer-component"]],
        inputs: {
          highfieldSite: "highfieldSite",
          siteTitle: "siteTitle",
          siteSubTitle: "siteSubTitle",
          loginPath: "loginPath",
          welcomePath: "welcomePath"
        },
        outputs: {
          onLogout: "onLogout"
        },
        ngContentSelectors: _c1,
        decls: 3,
        vars: 1,
        consts: [[3, "id"], ["id", "pageBody"]],
        template: function PublicContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.getStyleClass());
          }
        },
        encapsulation: 2
      });
    }
  }
  return PublicContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginComponent = /*#__PURE__*/(() => {
  class LoginComponent {
    constructor(currentUserService, router, route) {
      this.currentUserService = currentUserService;
      this.router = router;
      this.route = route;
      this.currentUserDispatcher = null;
      this.userInitialised = false;
      this.user = null;
    }
    ngOnInit() {
      this.currentUserDispatcher = this.currentUserService.dispatcher.subscribe(user => {
        this.user = user;
        this.userInitialised = user.Initialised;
        console.log(this.userInitialised);
        if (this.userInitialised && this.user.User !== null) {
          if (this.route.snapshot.queryParams["returnUrl"]) {
            let urlParams = this.returnParams(this.route.snapshot.queryParams["returnUrl"]);
            if (urlParams == null) {
              this.router.navigate([this.route.snapshot.queryParams["returnUrl"].split("?")[0]]);
            } else {
              this.router.navigate([this.route.snapshot.queryParams["returnUrl"].split("?")[0]], {
                queryParams: urlParams
              });
            }
          } else {
            this.router.navigate([""]);
          }
        }
      });
    }
    returnParams(link) {
      let linkSplit = link.split('?');
      if (linkSplit.length > 1) {
        let params = linkSplit[1].split('&');
        let pair = null;
        let data = {};
        params.forEach(d => {
          pair = d.split('=');
          data[`${pair[0]}`] = pair[1];
        });
        return data;
      } else {
        return null;
      }
    }
    ngOnDestroy() {
      if (this.currentUserDispatcher) {
        this.currentUserDispatcher.unsubscribe();
      }
    }
    static {
      this.ɵfac = function LoginComponent_Factory(t) {
        return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i1.CurrentUserService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginComponent,
        selectors: [["highfieldlayout-login-page"]],
        decls: 11,
        vars: 1,
        consts: [["src", "./assets/images/LoginHQ.png", 1, "background-image"], [1, "centered", "login-wrapper"], ["href", "https://qualifications.highfieldqualifications.com/"], ["src", "./assets/images/HQLogo.png", 1, "img-container"], [1, "auth-wrapper"], ["class", "top", 4, "ngIf"], [1, "bottom"], [1, "text"], [1, "cog"], [1, "fa", "fa-cog", "fa-spin", "fa-3x", "fa-fw"], [1, "top"]],
        template: function LoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "a", 2);
            i0.ɵɵelement(3, "img", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtemplate(5, LoginComponent_div_5_Template, 2, 0, "div", 5);
            i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
            i0.ɵɵtext(8, " Please wait while we check a few things ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵelement(10, "i", 9);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", (ctx.user == null ? null : ctx.user.User) == null);
          }
        },
        dependencies: [i4.NgIf, i1.LoginComponent],
        styles: [".background-image[_ngcontent-%COMP%]{width:100vw;height:100vh}.centered[_ngcontent-%COMP%]{position:absolute;inset:0;margin:auto}.login-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;width:467px;height:532px;background-color:#fff;padding:55px;box-shadow:#333 0 0 8px}@media screen and (max-width: 467px){.login-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;padding-left:10px}}.img-container[_ngcontent-%COMP%]{width:300px;height:auto}.auth-wrapper[_ngcontent-%COMP%]{width:100%;box-shadow:#000,5px,5px;position:relative}.auth-wrapper[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]{width:100%;position:absolute;z-index:1}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]{height:100%}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-bottom:25px}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]   .cog[_ngcontent-%COMP%]{display:flex;justify-content:center}.links-container[_ngcontent-%COMP%]{margin-top:20px;text-align:right;font-size:16px;color:#000}.links-container[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#333}"]
      });
    }
  }
  return LoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnauthorisedComponent = /*#__PURE__*/(() => {
  class UnauthorisedComponent {
    constructor(currentUserService, router, route, authService, authenticatedFailedRedirect) {
      this.currentUserService = currentUserService;
      this.router = router;
      this.route = route;
      this.authService = authService;
      this.authenticatedFailedRedirect = authenticatedFailedRedirect;
      this.currentUserDispatcher = null;
      this.userInitialised = false;
      this.user = null;
    }
    ngOnInit() {
      this.currentUserDispatcher = this.currentUserService.dispatcher.subscribe(user => {
        this.user = user;
        this.userInitialised = user.Initialised;
        if (this.userInitialised && this.user.User !== null) {
          if (this.route.snapshot.queryParams["returnUrl"]) {
            let urlParams = this.returnParams(this.route.snapshot.queryParams["returnUrl"]);
            if (urlParams == null) {
              this.router.navigate([this.route.snapshot.queryParams["returnUrl"].split("?")[0]]);
            } else {
              this.router.navigate([this.route.snapshot.queryParams["returnUrl"].split("?")[0]], {
                queryParams: urlParams
              });
            }
          } else {
            this.router.navigate([""]);
          }
        }
      });
    }
    returnParams(link) {
      let linkSplit = link.split('?');
      if (linkSplit.length > 1) {
        let params = linkSplit[1].split('&');
        let pair = null;
        let data = {};
        params.forEach(d => {
          pair = d.split('=');
          data[`${pair[0]}`] = pair[1];
        });
        return data;
      } else {
        return null;
      }
    }
    ngOnDestroy() {
      this.currentUserDispatcher?.unsubscribe();
    }
    async logoutClick() {
      await this.authService.logOutAsync();
      this.currentUserService.setCurrentUser(null);
      this.router.navigate([this.authenticatedFailedRedirect]);
      return false;
    }
    static {
      this.ɵfac = function UnauthorisedComponent_Factory(t) {
        return new (t || UnauthorisedComponent)(i0.ɵɵdirectiveInject(i1.CurrentUserService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.AuthenticationService), i0.ɵɵdirectiveInject('AuthenticatedCheckFailURL'));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UnauthorisedComponent,
        selectors: [["highfieldlayout-unauthorised-page"]],
        decls: 7,
        vars: 0,
        consts: [[1, "login-background-image"], [1, "centered", "login-wrapper"], [1, "auth-wrapper"]],
        template: function UnauthorisedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "p");
            i0.ɵɵtext(4, "Unfortunately you do not appear to have access to this area.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "p");
            i0.ɵɵtext(6, "If you need to log in as a different user then please click the button below.");
            i0.ɵɵelementEnd()()()();
          }
        },
        styles: [".login-background-image[_ngcontent-%COMP%]{height:100vh;width:100vw}.login-wrapper[_ngcontent-%COMP%]{text-align:center;width:467px;height:532px;background-color:#fff;padding:50px 15px 0;box-shadow:#333 0 0 8px}@media screen and (max-width: 467px){.login-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;padding-left:10px}}.centered[_ngcontent-%COMP%]{position:absolute;inset:0;margin:auto}.img-container[_ngcontent-%COMP%]{width:300px;height:auto}.auth-wrapper[_ngcontent-%COMP%]{box-shadow:#000,5px,5px;position:relative}.auth-wrapper[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]{position:absolute;z-index:1}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]{height:100%;padding:160px 0}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{padding-left:40px;margin-bottom:25px}.auth-wrapper[_ngcontent-%COMP%]   .bottom[_ngcontent-%COMP%]   .cog[_ngcontent-%COMP%]{padding-left:135px}.links-container[_ngcontent-%COMP%]{margin-top:20px;text-align:right;font-size:16px;color:#000}.links-container[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#333}"]
      });
    }
  }
  return UnauthorisedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseContainerComponent = /*#__PURE__*/(() => {
  class BaseContainerComponent {
    constructor(currentUserService, loadingService) {
      this.currentUserService = currentUserService;
      this.loadingService = loadingService;
      this.color = 'primary';
      this.mode = 'indeterminate';
      this.loadingData = false;
      this.loadingMessage = "";
      this.onLoadingChanged = null;
      this.onLoadingChanged = this.loadingService.loadingChanged.subscribe(isLoading => {
        this.loadingData = isLoading;
        this.loadingMessage = this.loadingService.loadingMessage;
      });
    }
    static {
      this.ɵfac = function BaseContainerComponent_Factory(t) {
        return new (t || BaseContainerComponent)(i0.ɵɵdirectiveInject(i1.CurrentUserService), i0.ɵɵdirectiveInject(LoadingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseContainerComponent,
        selectors: [["highfieldlayout-basecontainer-component"]],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 3,
        consts: [["id", "WorkingPanel", 4, "ngIf"], ["class", "spinner-border", "style", "width: 3rem; height: 3rem;", "role", "status", 4, "ngIf"], ["id", "spinnerMessage", "class", "SpinnerBackground", 4, "ngIf"], ["id", "WorkingPanel"], ["role", "status", 1, "spinner-border", 2, "width", "3rem", "height", "3rem"], [1, "sr-only"], ["id", "spinnerMessage", 1, "SpinnerBackground"]],
        template: function BaseContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, BaseContainerComponent_div_1_Template, 1, 0, "div", 0)(2, BaseContainerComponent_div_2_Template, 3, 0, "div", 1)(3, BaseContainerComponent_div_3_Template, 2, 1, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loadingData);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loadingData);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loadingData && ctx.loadingMessage);
          }
        },
        dependencies: [i4.NgIf],
        styles: ["#WorkingPanel[_ngcontent-%COMP%]{width:100%;height:100%;position:fixed;top:0;left:0;text-align:center;z-index:999999;background-color:#fff;opacity:.5}#spinner[_ngcontent-%COMP%]{text-align:center;z-index:9999999;position:fixed;top:50%;left:50%;margin-top:-50px;margin-left:-50px}#spinnerMessage[_ngcontent-%COMP%]{text-align:center;z-index:9999999;position:fixed;top:75%;right:0;left:0;margin-top:-50px;margin-right:auto;margin-left:auto;background-color:gray;color:#fff;font-weight:700;font-size:2em;padding:5px;max-width:50%;border-radius:5px}"]
      });
    }
  }
  return BaseContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocalSettingsService = /*#__PURE__*/(() => {
  class LocalSettingsService {
    constructor(storedSettingService) {
      this.storedSettingService = storedSettingService;
      this.localSettingChanged = new BehaviorSubject("");
      this.getSetting = key => {
        return this.storedSettingService.getSetting('highfieldlocalsettings_' + key);
      };
      this.setSetting = (key, value) => {
        this.storedSettingService.setSetting('highfieldlocalsettings_' + key, value);
        this.localSettingChanged.next(key);
      };
      this.removeSetting = key => {
        this.storedSettingService.removeSetting('highfieldlocalsettings_' + key);
        this.localSettingChanged.next(key);
      };
      this.getAll = () => {
        return localStorage;
      };
      this.clearSettings = () => {
        var currentItems = this.storedSettingService.getAll();
        for (var i = 0; i < currentItems.length; i++) {
          let currentKey = currentItems.key(i);
          if (currentKey.startsWith("highfieldlocalsettings_")) {
            this.storedSettingService.removeSetting(currentKey);
            this.localSettingChanged.next(currentKey.substr(currentKey.indexOf("_") + 1, currentKey.length - (currentKey.indexOf("_") + 1)));
          }
        }
      };
    }
    static {
      this.ɵfac = function LocalSettingsService_Factory(t) {
        return new (t || LocalSettingsService)(i0.ɵɵinject(i1$1.StoredSettingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LocalSettingsService,
        factory: LocalSettingsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LocalSettingsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ParameterService = /*#__PURE__*/(() => {
  class ParameterService {
    constructor(localSettingsService) {
      this.localSettingsService = localSettingsService;
      this.parameters = new Map();
    }
    setParameterValue(name, value) {
      this.parameters.set(name.toLowerCase(), value);
      this.localSettingsService.setSetting("parameter-" + name, value);
    }
    getParameterValue(name) {
      if (this.parameters.has(name.toLowerCase())) {
        let _value = this.parameters.get(name.toLowerCase());
        if (_value == undefined) {
          return '';
        } else {
          return _value;
        }
      } else {
        return '';
      }
    }
    setupLinks(routeSnapshot) {
      for (var i = 0; i < routeSnapshot.queryParamMap.keys.length; i++) {
        this.setParameterValue(routeSnapshot.queryParamMap.keys[i], routeSnapshot.queryParams[routeSnapshot.queryParamMap.keys[i]]);
      }
    }
    static {
      this.ɵfac = function ParameterService_Factory(t) {
        return new (t || ParameterService)(i0.ɵɵinject(LocalSettingsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ParameterService,
        factory: ParameterService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ParameterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AngularHighfieldlayoutService = /*#__PURE__*/(() => {
  class AngularHighfieldlayoutService {
    constructor() {}
    static {
      this.ɵfac = function AngularHighfieldlayoutService_Factory(t) {
        return new (t || AngularHighfieldlayoutService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AngularHighfieldlayoutService,
        factory: AngularHighfieldlayoutService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AngularHighfieldlayoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AngularHighfieldlayoutComponent = /*#__PURE__*/(() => {
  class AngularHighfieldlayoutComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function AngularHighfieldlayoutComponent_Factory(t) {
        return new (t || AngularHighfieldlayoutComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AngularHighfieldlayoutComponent,
        selectors: [["lib-angular-highfieldlayout"]],
        decls: 2,
        vars: 0,
        template: function AngularHighfieldlayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, " angular-highfieldlayout works! ");
            i0.ɵɵelementEnd();
          }
        },
        encapsulation: 2
      });
    }
  }
  return AngularHighfieldlayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AngularHighfieldlayoutModule = /*#__PURE__*/(() => {
  class AngularHighfieldlayoutModule {
    static forRoot() {
      return {
        ngModule: AngularHighfieldlayoutModule
      };
    }
    static {
      this.ɵfac = function AngularHighfieldlayoutModule_Factory(t) {
        return new (t || AngularHighfieldlayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AngularHighfieldlayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, OverlayModule, AngularHighfieldcommonModule.forRoot(), AngularHighfieldwebapiModule.forRoot(), AngularHighfieldauthModule.forRoot()]
      });
    }
  }
  return AngularHighfieldlayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MenuSet {
  constructor() {
    this.titleOverride = null;
    this.selected = false;
    this.default = false;
  }
}
class TopMenuItem {
  constructor() {
    this.selected = false;
    this.default = false;
    this.display = true;
  }
}

/*
 * Public API Surface of angular-highfieldlayout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdminContainerComponent, AngularHighfieldlayoutComponent, AngularHighfieldlayoutModule, AngularHighfieldlayoutService, AuthenticationComponent, BaseContainerComponent, CustomerContainerComponent, LoadingService, LocalSettingsService, LoginComponent, MenuSet, ParameterService, PublicContainerComponent, TopMenuItem, UnauthorisedComponent };
